export default __webpack_public_path__ + "static/media/icon-shop.85be525a.svg";